var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
/**
 * @hidden
 */
export function templateRendering(template, listeners) {
    if (!template) {
        return undefined;
    }
    var scopedSlot = gh ?
        this.$slots[template] ||
            (template.toLowerCase ? this.$slots[template.toLowerCase()]
                : null) :
        this.$scopedSlots[template] ||
            (template.toLowerCase ? this.$scopedSlots[template.toLowerCase()]
                : null);
    // @ts-ignore
    if (typeof template === 'string' && scopedSlot) {
        // @ts-ignore
        return { type: 'slot', render: scopedSlot, listeners: listeners };
    }
    if (typeof template === 'string' || typeof template === 'object' ||
        (typeof template === 'function' && template.component)) {
        return { type: 'component', render: template, listeners: listeners };
    }
    return { type: 'renderFunction', render: template, listeners: listeners };
}
/**
 * @hidden
 */
export function getTemplate(_a) {
    var h = _a.h, template = _a.template, defaultRendering = _a.defaultRendering, defaultSlots = _a.defaultSlots, additionalProps = _a.additionalProps, additionalListeners = _a.additionalListeners, swapDefaultSlots = _a.swapDefaultSlots;
    if (!template) {
        return defaultRendering;
    }
    var events;
    var props;
    var componentOptions;
    if (gh) {
        var passedProps = defaultRendering ? defaultRendering.props : {};
        events = __assign(__assign({}, transformListeners(additionalListeners)), template.listeners);
        props = __assign(__assign(__assign({}, passedProps), additionalProps), events);
        componentOptions = __assign(__assign({}, props), events);
    }
    else {
        var hasComponentOptions = defaultRendering && defaultRendering.componentOptions;
        var defaultListeners = hasComponentOptions ?
            defaultRendering.componentOptions.listeners : {};
        var defaultProps = hasComponentOptions ?
            defaultRendering.componentOptions.propsData : {};
        events = __assign(__assign(__assign(__assign({}, defaultListeners), additionalListeners), transformListeners(additionalListeners)), template.listeners);
        props = __assign(__assign(__assign({}, defaultProps), additionalProps), events);
        componentOptions = { props: props, on: events };
    }
    if (template.type === 'slot') {
        var slotTemplate = template.render({ props: props, listeners: events, methods: events,
            defaultSlots: defaultSlots });
        return slotTemplate ? slotTemplate[0] : undefined;
    }
    else if (template.type === 'renderFunction') {
        if (swapDefaultSlots) {
            return template.render(h, defaultRendering, defaultSlots, props, events);
        }
        return template.render(h, defaultRendering, props, events, defaultSlots);
    }
    else {
        return h(template.render, componentOptions, gh ? function () { return [defaultSlots]; } : [defaultSlots]);
    }
}
/**
 * @hidden
 */
export function transformListeners(listeners) {
    if (!listeners) {
        return listeners;
    }
    var newListeners = {};
    var listenersKeys = Object.keys(listeners);
    for (var i = 0; i < listenersKeys.length; i++) {
        var currentKey = listenersKeys[i];
        newListeners['on' + currentKey.charAt(0).toUpperCase() + currentKey.slice(1)] =
            listeners[currentKey];
    }
    return newListeners;
}
